// ============================================================
// OCCURRENCE BUILDER
// ============================================================

export function createOccurrence({
    template,
    operationalDate,
    dueDate,
    expected = true,
    generate = false,
    reason = '',
    code = ''

}) {

    return {
        templateId: template.id,
        template,
        operationalDate,
        dueDate,
        expected,
        generate,
        reason,
        code,
        taskCreated: false,
        taskId: null,
        skipped: false,
        missed: false,
        completed: false
    }

}